import { usePermissions } from '@michelin/central-provider';
import { useParams } from 'react-router-dom';
import { useOptionalLocationST } from './useLocation';

const usePermissionsSPP = (workingStNumber?: string) => {
  const { stNumber: urlStNumber, btNumber } = useParams<{ stNumber: string, btNumber: string }>();
  const stNumber = workingStNumber || urlStNumber;
  const location = useOptionalLocationST(stNumber);
  const permissions = usePermissions();

  const allowsAction = (actionPath: string, allowWhileLoading:boolean = false): boolean => {
    const action = actionPath.split('.').pop();
    if (action === 'manage_all_providers') return permissions.allowsAction(actionPath);
    if (!stNumber) return permissions.allowsAction(actionPath);
    if (!location.isSuccess) return allowWhileLoading;
    if (!location?.data) return false;
    if (location.data.servicing_dealer_bt === btNumber && !(action === 'read' || action === 'list')) return false;
    return permissions.allowsAction(actionPath);
  };

  return {
    allowsAction,
    profile: permissions.profile,
    location: permissions.location,
    isLoading: !location.isSuccess,
    stNumber,
  };
};

export default usePermissionsSPP;
